import { Layout } from 'antd';
import * as React from 'react';
import SchEInKindContributionsApiService from '../../api/SchEInKindContributionsApiService';
import SchEInKindContributionsDTO from '../../models/SchEInKindContributionsDTO';
import DataTableColumnUtil from '../shared/DataTable/DataTableColumnUtil';
import DataTable, { DataTableColumnProps } from '../shared/DataTable/DataTable';
import Dr2AmendedStatuses from '../../consts/Dr2AmendedStatuses';
import Dr2AmendedIndicators from '../../consts/Dr2AmendedIndicators';

const { Content } = Layout;

interface SchEInKindContributionHistoryTableProps {
  contributionId: string;
}

interface SchEInKindContributionHistoryTableState {
}

class SchEInKindContributionHistoryTable extends React.Component<SchEInKindContributionHistoryTableProps, SchEInKindContributionHistoryTableState> {
  constructor(props: SchEInKindContributionHistoryTableProps) {
    super(props);

    this.state = {
    };
  }

  render() {
    const { contributionId } = this.props;
    return (
      <Content className="content-pad">
        <DataTable
          columns={this.getTableColumns()}
          fetchData={{
            fetch: function (tableRequest) { return SchEInKindContributionsApiService.getInKindContributionHistory(tableRequest, contributionId); },
            failureMessage: 'Failed to retrieve contribution history'
          }}
          serverSide={true}
          styleOptions={{ compact: true, alternatingRowHighlight: true }}

          tableProps={{
            rowKey: 'contributionIdAndSeq',
            sortDirections: ['ascend', 'descend'],
            locale: { emptyText: 'Contribution history not available.' }
          }}
        />
      </Content>
    );
  }

  private getTableColumns = (): DataTableColumnProps<SchEInKindContributionsDTO>[] => {
    const tableColumns: DataTableColumnProps<SchEInKindContributionsDTO>[] = [
      DataTableColumnUtil.Date('Date', 'inKindContributionDt', 100),
      DataTableColumnUtil.Address('Contributor', 'contributorName',
        (c) => ({
          name: c.contributorName,
          line1: c.contributorAddressLine1,
          line2: c.contributorAddressLine2,
          city: c.contributorCity,
          state: c.contributorState,
          zip: c.contributorZip
        })
      ),
      DataTableColumnUtil.Currency('Amount', 'inKindContributionAmt'),
      DataTableColumnUtil.DropdownMulti('Status', 'status',
        [
          { text: Dr2AmendedStatuses.ORIGINAL, value: Dr2AmendedIndicators.ORIGINAL },
          { text: Dr2AmendedStatuses.AMENDED, value: Dr2AmendedIndicators.AMENDED },
          { text: Dr2AmendedStatuses.ADJUSTED, value: Dr2AmendedIndicators.ADJUSTED },
          { text: Dr2AmendedStatuses.DELETED, value: Dr2AmendedIndicators.DELETED }
        ]),
        DataTableColumnUtil.Text('Last Updated By', 'updatedBy'),
        DataTableColumnUtil.Date('Last Updated On', 'updatedOn'),
    ];
    return tableColumns;
  }
}

export default SchEInKindContributionHistoryTable;
